import { render, staticRenderFns } from "./PlanResources.vue?vue&type=template&id=4c540f44"
import script from "./PlanResources.vue?vue&type=script&lang=js"
export * from "./PlanResources.vue?vue&type=script&lang=js"
import style0 from "./PlanResources.vue?vue&type=style&index=0&id=4c540f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports